import React from "react";
import { Link } from "react-router-dom";
import NavigationBar from "../../components/ui/NavigationBar";
import { ParallaxComponent } from "../../components/ui/ParallaxComponent";

const VisioneerPage = () => {
  return (
    <div className="min-h-screen bg-background">
        <NavigationBar />

      <ParallaxComponent />

      <section className="max-w-4xl mx-auto px-6 py-24 text-center">
        <p className="text-sm uppercase tracking-[0.3em] text-muted-foreground mb-4">
          Coming Soon
        </p>
        <h1 className="text-4xl md:text-6xl font-semibold tracking-tight text-foreground mb-6">
          Visioneer
        </h1>
        <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
          Mentorship, built into the way you learn. Visioneer connects
          learners with real builders — founders, engineers, and creators —
          who've already done what you're working toward.
        </p>
      </section>

      <section className="max-w-5xl mx-auto px-6 py-16 grid md:grid-cols-2 gap-10">
        <div className="rounded-2xl border border-border p-8">
          <h2 className="text-2xl font-semibold text-foreground mb-3">
            For Learners
          </h2>
          <p className="text-muted-foreground mb-4">
            Watch short lessons from real builders, join live mentorship
            sessions, and earn credentials for applying what you learn —
            not just for watching it.
          </p>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li>• Learn from people who've built the thing, not just taught it</li>
            <li>• Micro-mentorship sessions built around your goals</li>
            <li>• Credentials tied to real project completion</li>
          </ul>
        </div>

        <div className="rounded-2xl border border-border p-8">
          <h2 className="text-2xl font-semibold text-foreground mb-3">
            For Mentors
          </h2>
          <p className="text-muted-foreground mb-4">
            Visioneer is opening applications soon for builders who want to
            mentor the next generation of learners. If you've built
            something real, there's a place for you here.
          </p>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li>• Share real experience through short-form lessons</li>
            <li>• Run live sessions and challenges for motivated learners</li>
            <li>• Get recognized as a verified builder on Nesolearn</li>
          </ul>
        </div>
      </section>

      <section className="max-w-2xl mx-auto px-6 py-16 text-center">
        <h2 className="text-2xl font-semibold text-foreground mb-4">
          Visioneer isn't live yet — but you can get ready.
        </h2>
        <p className="text-muted-foreground mb-8">
          Create your Nesolearn account now so you're first in line when
          mentor applications and learner access open up.
        </p>
        <Link
          to="/authentication-portal"
          className="inline-flex items-center justify-center rounded-full bg-foreground text-background px-8 py-3 text-sm font-medium hover:bg-foreground/90 transition-colors"
        >
          Create Your Account
        </Link>
      </section>
    </div>
  );
};

export default VisioneerPage;